import { createSlice } from '@reduxjs/toolkit';
import { DashboardStore } from 'types/dashboard';

// initial state
const initialState: DashboardStore = {
    selectedDashboard: undefined,
    dashboardList: [],
    isLoading: true,
    analyticsProvider: 'boldbi'
};

// ==============================|| SLICE - DASHBOARD ||============================== //

const dashboard = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboardList(state, action) {
            state.dashboardList = action.payload;
        },

        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },

        setSelectedDashboard(state, action) {
            state.selectedDashboard = action.payload;
        },

        setAnalyticsProvider(state, action) {
            state.analyticsProvider = action.payload;
        }
    }
});

export default dashboard.reducer;

export const { setDashboardList, setSelectedDashboard, setIsLoading, setAnalyticsProvider } = dashboard.actions;
